import React from 'react';
import { motion } from 'framer-motion';

const StoryHeroRo = () => (
  <section className="relative min-h-[50vh] flex items-center pt-28 pb-16 overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-brand-surfaceLight via-brand-dark to-black"></div>
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-accent/5 blur-[150px] rounded-full"></div>
    <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10 text-center">
      <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-brand-accent font-semibold tracking-widest uppercase text-sm mb-4">
        Narațiunea
      </motion.p>
      <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}
        className="text-4xl md:text-6xl font-display font-bold text-white mb-6 text-glow">
        Povestea
      </motion.h1>
      <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}
        className="text-xl text-gray-400 max-w-2xl mx-auto">
        O epopee a supraviețuirii, ingeniozității și renașterii civilizaționale — urmărind călătoria extraordinară a umanității de la pragul extincției până la pragul stelelor.
      </motion.p>
    </div>
  </section>
);

export default StoryHeroRo;